<template>
    <thead :class="setCustomClassHead()">
        <tr>
            <th v-if="header.selection && header.selection.active" >
                <checkbox v-model="header.selectAll" @input="callEventSelection"></checkbox>
            </th>
            <th v-for="(value, key) in header.list" @click="sortBy($event, key)" :class="setCustomClassCell(key)">
                <span>{{ value }}</span>
            </th>
            <th v-if="actions.list && actions.list.length > 0" style="width: 1%;" class="text-center">
                {{ actions.label }}
            </th>
        </tr>
    </thead>
</template>

<script>
    export default {
        data: function() {
            return {
                selectAllStatus: false,
            }
        },
        props: {
            selected: Boolean,
            header: Object,
            actions: Object
        },
        methods: {
            sortBy: function(e, sortKey) {
                if (!this.header.sort) {
                    return;
                }

                var sortKeyFound = false;

                this.header.sort.list.forEach((obj) => {
                    if (obj.key == sortKey) {
                        obj.direction = obj.direction == 'asc' ? 'desc' : 'asc';
                        sortKeyFound = true;
                    }
                });

                if (!sortKeyFound) {
                    this.header.sort.list.push({ key: sortKey, direction: 'desc' });
                }

                // TODO :: Bind / refresh information using API server

                this.header.sort.apiEvent(this.header.sort.list);
            },
            callEventSelection: function($event) {
                console.log('callEventSelection', $event);
                // if (this.header.selection.event) {
                //     this.header.selection.event(event);
                //
                //     var selectAll = !this.selected;
                //
                // }
                this.$emit('selectAll', $event);
            },
            setCustomClassCell: function(key) {
                // var css = (this.header.customClassCell) ? this.header.customCellClass[key] : '';
                // if (this.header.sort) {
                //     this.header.sort.list.forEach((obj) => {
                //         if (key == obj.key) {
                //             return css + ' sortable ' + obj.direction;
                //         }
                //     });
                // }
                //
                // return css;

                return (this.header.customClassCell) ? this.header.customClassCell[key] : '';
            },
            setCustomClassHead: function(){
                return (this.header.customClassHead) ? this.header.customClassHead : '';
            },
        }
    }
</script>



// WEBPACK FOOTER //
// baseHeader.vue?3c4ceef4